/**
 * Init slider showcase.
 */

const sliderShowcase = function() {
	const $slider =	$('.js-slider-showcase');
	const $count = $('.js-slider-count')

	if( ! $slider.length ) {
		return;
	}

	if( $count.length ) {
		$slider.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
		    let i = (currentSlide ? currentSlide : 0) + 1;
		    $count.text(i + '/' + slick.slideCount);
		});
	}
	
	$slider.slick({
		appendArrows: '.slider__actions',
		prevArrow: '.slider__prev',
		nextArrow: '.slider__next',
		autoplay: true,
		autoplaySpeed: 2000,
	})
}; 

sliderShowcase();
